import React, { ChangeEvent } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

export type CheckBoxProps = {
  name: string,
  label: string,
  value?: number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
} & React.InputHTMLAttributes<HTMLInputElement>

const CheckBoxContainer = styled.div`
  width: 100%;
`

const Text = styled.span`
  font-size: .875rem;
  margin-left: .5rem;
  line-height: 1.5rem;
  cursor: pointer;

  &.-disabled {
    color: ${props => props.theme.members.colors.silver._100};
    cursor: not-allowed;
  }
`

const CustomCheckbox = styled.span`
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  width: 1rem;
  height: 1rem;
  border: 1px solid ${props => props.theme.members.colors.silver._70};
  background-color: ${props => props.theme.members.colors.white};
  
  &::after {
    content: '';
    display: block;
    position: absolute;
    transform: rotate(45deg);
    background: none;
    border: 2px solid ${props => props.theme.members.colors.white};
    border-top: 0;
    border-left: 0;
    width: .437rem;
    height: .75rem;
    left: 4px;
    top: -1px;
    opacity: 0;
  }

  &.-disabled {
    border: 1px solid ${props => props.theme.members.colors.silver._30} !important;
    background-color: ${props => props.theme.members.colors.silver._30} !important;
  }

  &.-disabled::after {
    border-color: ${props => props.theme.members.colors.silver._70} !important;
  }
`

const HiddenCheckbox = styled.input`
  display: none;

  &:checked + ${CustomCheckbox}::after {
    opacity: 1;
  }

  &:checked + ${CustomCheckbox} {
    border: 1px solid ${props => props.theme.members.colors.lightGreen};
    background-color: ${props => props.theme.members.colors.lightGreen};
  }
`

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;

  &.-disabled ${CustomCheckbox} {
    color: ${props => props.theme.members.colors.silver._100};
    cursor: not-allowed;
  }

  &.-disabled ${CustomCheckbox}::before {
    background-color: #dbdde3;
    border-color: ${props => props.theme.members.colors.silver._30};
  }
`

export const StyledCheckbox: React.FC<CheckBoxProps> = (props: CheckBoxProps) => {
  const { register } = useFormContext()

  return (
    <CheckBoxContainer>
      <Label className={props.disabled && '-disabled'}>
        <HiddenCheckbox type='checkbox' {...props} {...register(props.name, { onChange: (e: ChangeEvent<HTMLInputElement>) => props.onChange && props.onChange(e) })} />
        <CustomCheckbox className={props.disabled && '-disabled'} />
        <Text className={props.disabled && '-disabled'} >{props.label}</Text>
      </Label>
    </CheckBoxContainer>
  )
}

